import React from 'react';
import './KPICardsContainer.css';

interface KPICardsContainerProps {
  children: React.ReactNode;
  className?: string;
  buttons?: React.ReactNode; // Add a prop for buttons
}

const KPICardsContainer: React.FC<KPICardsContainerProps> = ({ 
  children, 
  className = '',
  buttons
}) => {
  return (
    <div className="kpi-cards-wrapper">
      <div className={`kpi-cards-container ${className}`}>
        {children}
      </div>
      {buttons && (
        <div className="kpi-cards-buttons">
          {buttons}
        </div>
      )}
    </div>
  );
};

export default KPICardsContainer;